<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row flex-nowrap md:gap-3 items-center justify-between">
  <div class="flex flex-wrap w-1/4 justify-start">
    <img
      [routerLink]="['/campaigns']"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
      alt="campaign"
    />
    <h1 *ngIf="!isEdit" class="headeradminui-text pl-2">Create Campaign</h1>
    <h1 *ngIf="isEdit && viewMode" class="headeradminui-text pl-2">
      View Campaign
    </h1>
    <h1 *ngIf="isEdit && !viewMode" class="headeradminui-text pl-2">
      Edit Campaign
    </h1>
  </div>
</div>

<nz-spin [nzSpinning]="pageLoading">
  <nz-card>
    <!-- Action Buttons -->
    <div nz-row nzJustify="end" class="mb-4" nzGutter="16">
      <div nz-col>
        <nz-switch
          [(ngModel)]="isVisible"
          [ngModelOptions]="{ standalone: true }"
          [nzDisabled]="viewMode"
          nzCheckedChildren="Visible"
          nzUnCheckedChildren="Hidden"
        ></nz-switch>
      </div>
      <div *ngIf="isEdit" nz-col>
        <button
          *ngIf="viewMode"
          (click)="editForm()"
          nz-button
          nzType="primary"
        >
          <span nz-icon nzType="edit"></span>
          Edit Campaign
        </button>
      </div>
    </div>

    <!-- Main Form -->
    <form [formGroup]="validateForm" nz-form>
      <!-- Partner, Title, Category, Duration Row -->
      <div nz-row nzGutter="16">
        <div nz-col nzSpan="8">
          <label class="form-label required">Select Partner</label>
          <nz-select
            [(ngModel)]="selectedPartnerId"
            [ngModelOptions]="{ standalone: true }"
            class="w-[100%]"
            nzAllowClear
            nzPlaceHolder="Select a Partner"
            nzShowSearch
            [nzDisabled]="viewMode"
          >
            <nz-option
              *ngFor="let pt of partners"
              [nzLabel]="pt.partner"
              [nzValue]="pt.partnerId"
            ></nz-option>
          </nz-select>
        </div>
        <div nz-col nzSpan="10">
          <nz-form-item>
            <nz-form-label nzFor="title" nzRequired nzSpan="24">
              Title
            </nz-form-label>
            <nz-form-control nzErrorTip="Please input Title" nzSpan="24">
              <input
                formControlName="title"
                id="title"
                nz-input
                placeholder="Title"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzFor="durationMinutes" nzRequired nzSpan="24">
              Duration in Minutes
            </nz-form-label>
            <nz-form-control
              nzErrorTip="Campaign duration cannot be less than 10 min"
              nzSpan="24"
            >
              <input
                formControlName="durationMinutes"
                nz-input
                placeholder="Duration in Minutes"
                type="number"
                min="10"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div class="mt-3" nz-row nzGutter="16">
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> Category </nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="selectedCategory"
                id="campaignCategory"
                nzAllowClear
                nzPlaceHolder="Select a Category"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let category of campaignCategories"
                  [nzLabel]="category.label"
                  [nzValue]="category.value"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzFor="campaignDate" nzRequired nzSpan="24">
              Campaign Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateFormat"
                [nzShowTime]="{ nzFormat: 'HH:mm' }"
                formControlName="campaignDate"
                id="campaignDate"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzFor="numberOfAttendees" nzSpan="24">
              Number of Attendees
            </nz-form-label>
            <nz-form-control
              nzErrorTip="Number of Attendees cannot be negative"
              nzSpan="24"
            >
              <input
                formControlName="numberOfAttendees"
                nz-input
                placeholder="Number of Attendees"
                type="number"
                min="0"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Description -->
      <div class="mt-3" nz-row>
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label nzFor="description" nzRequired nzSpan="24">
              Description
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <textarea
                formControlName="description"
                id="description"
                nz-input
                placeholder="Campaign Description"
                rows="6"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <!-- Venue Details -->
    <nz-divider nzOrientation="left" nzText="Venue Details"></nz-divider>
    <div nz-row>
      <div nz-col nzSpan="12">
        <nz-switch
          [(ngModel)]="offlineCampaign"
          [nzDisabled]="viewMode"
          nzCheckedChildren="Offline"
          nzUnCheckedChildren="Online"
        ></nz-switch>
      </div>
    </div>
    <div *ngIf="offlineCampaign" nz-row class="mt-3">
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="venueName" nzRequired> Venue Name </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="venue"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="viewMode"
              nz-input
              placeholder="Venue Name"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Presenter Details -->
    <nz-divider nzOrientation="left" nzText="Presenter Details"></nz-divider>
    <div
      *ngFor="let row of presenterRows; let i = index"
      nz-row
      nzGutter="16"
      style="margin-bottom: 20px; align-items: center"
    >
      <div nz-col nzSpan="8">
        <nz-select
          [disabled]="viewMode || row.alreadyPaid"
          [(ngModel)]="row.presenterId"
          [ngModelOptions]="{ standalone: true }"
          nzPlaceHolder="Select Presenter"
          nzShowSearch
          nzAllowClear
          (ngModelChange)="onPresenterChange(i)"
          style="width: 100%"
        >
          <nz-option
            *ngFor="let expert of filteredExperts(i)"
            [nzLabel]="expert.expertId"
            [nzValue]="expert.name"
          ></nz-option>
        </nz-select>
      </div>
      <div nz-col nzSpan="4" *ngIf="row.presenterId">
        <label style="margin-right: 8px">Pay?</label>
        <nz-switch
          [(ngModel)]="row.isPaid"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="viewMode || row.alreadyPaid"
        ></nz-switch>
      </div>
      <div nzSpan="6" *ngIf="row.isPaid" nz-row>
        <input
          nz-input
          type="number"
          [(ngModel)]="row.amount"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Amount"
          [disabled]="viewMode || row.alreadyPaid"
        />
        <span> INR (₹)</span>
        <span *ngIf="row.alreadyPaid" class="pl-2 text-gray-500">
          (already fixed or already paid out, cannot be changed)
        </span>
      </div>
      <div nz-col nzSpan="2" *ngIf="i > 0">
        <button
          nz-button
          nzType="default"
          nzDanger
          (click)="removeRow(i)"
          [disabled]="viewMode || row.alreadyPaid"
        >
          X
        </button>
      </div>
    </div>
    <button
      nz-button
      nzType="default"
      (click)="addPresenterRow()"
      style="margin-top: 15px"
      [disabled]="viewMode"
    >
      + Add More Presenter
    </button>

    <!-- Campaign Image -->
    <nz-divider nzOrientation="left" nzText="Campaign Image"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <span><b>Campaign Image (Optional)</b></span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadImage($event)"
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div
          *ngIf="imagePreviewUrl || imageLink"
          nz-col
          nzSpan="12"
          style="width: 300px"
          class="pt-3"
        >
          <img
            [src]="imagePreviewUrl || imageLink"
            class="h-fit object-cover"
            alt="campaign"
          />
        </div>
      </div>
    </div>

    <!-- Activity Images -->
    <nz-divider nzOrientation="left" nzText="Activity Images"></nz-divider>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span><b>Activity Images (Optional, Multiple)</b></span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadActivityImages($event)"
          multiple
          accept=".jpg,.jpeg,.png"
          type="file"
        />
      </div>
    </div>
    <div class="flex flex-wrap justify-start items-center pr-4 pb-5">
      <div
        *ngFor="let preview of activityImagesPreviewUrls; let i = index"
        class="pt-5 pr-3"
      >
        <nz-card style="width: 160px" class="clickable">
          <img
            [src]="preview"
            (click)="openGallery(preview)"
            (keyup.enter)="openGallery(preview)"
            tabindex="0"
            role="button"
            class="h-fit object-cover clickable"
            alt="activity preview"
          />
        </nz-card>
        <div class="pt-2">
          <button
            *ngIf="!viewMode"
            (click)="deleteActivityImagePreview(i)"
            nz-button
            nzDanger
            nzSize="small"
          >
            <span nz-icon nzType="delete"></span>
            Delete
          </button>
        </div>
      </div>
      <div
        *ngFor="let data of activityImagesLinks; let i = index"
        class="pt-5 pr-3"
      >
        <nz-card style="width: 160px" class="clickable">
          <img
            [src]="data"
            (click)="openGallery(data)"
            (keyup.enter)="openGallery(data)"
            tabindex="0"
            role="button"
            class="h-fit object-cover clickable"
            alt="activity"
          />
        </nz-card>
        <div class="pt-2">
          <button
            *ngIf="!viewMode"
            (click)="deleteActivityImage(i)"
            nz-button
            nzDanger
            nzSize="small"
          >
            <span nz-icon nzType="delete"></span>
            Delete
          </button>
        </div>
      </div>
    </div>

    <!-- Test Campaign (only for create) -->
    <div nz-row *ngIf="!isEdit">
      <div nz-col>
        <label [(ngModel)]="testCampaign" [ngModelOptions]="{ standalone: true }" nz-checkbox>
          Test Campaign
        </label>
      </div>
    </div>

    <!-- Action Buttons -->
    <nz-divider></nz-divider>
    <div *ngIf="!viewMode" nz-row nzJustify="space-between">
      <div nz-col>
        <button [routerLink]="['/campaigns']" nz-button nzType="default">
          <span nz-icon nzType="arrow-left"></span>
          Cancel
        </button>
      </div>
      <div nz-col>
        <button
          (click)="addOrUpdateCampaign()"
          nz-button
          nzType="primary"
          [nzLoading]="loading"
        >
          <span nz-icon [nzType]="isEdit ? 'save' : 'plus'"></span>
          {{ isEdit ? 'Update Campaign' : 'Create Campaign' }}
        </button>
      </div>
    </div>
  </nz-card>
</nz-spin>

<nz-modal
  [(nzVisible)]="galleryVisible"
  nzTitle="Activity Image"
  (nzOnCancel)="closeGallery()"
  [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <img [src]="galleryImage" class="w-full h-fit object-contain" alt="gallery" />
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="payoutResultsModalVisible"
  nzTitle="Campaign Payout Results"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  (nzOnOk)="acknowledgePayoutResults()"
  (nzOnCancel)="acknowledgePayoutResults()"
  nzOkText="Ok"
>
  <ng-container *nzModalContent>
    <nz-table
      [nzData]="payoutResults"
      [nzShowPagination]="false"
      nzSize="small"
    >
      <thead>
        <tr>
          <th>Expert</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let result of payoutResults">
          <td>{{ result.expertName }}</td>
          <td>{{ result.amount }}</td>
          <td>
            <nz-tag [nzColor]="payoutStatusColor(result.status)">
              {{ result.status }}
            </nz-tag>
          </td>
          <td>{{ result.reason || '-' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>
